/**
 * appSlice — manages app-wide UI state (dark mode, modals, etc.).
 */
import { createSlice } from '@reduxjs/toolkit';
import { loadDarkMode, loadTheme, saveTheme } from '../../utils/storage';

const initialState = {
  darkMode: loadDarkMode(),
  theme: loadTheme(),
  showResultModal: false,
  showHowToPlay: false,
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    toggleDarkMode(state) {
      state.darkMode = !state.darkMode;
    },

    setDarkMode(state, action) {
      state.darkMode = action.payload;
    },

    setTheme(state, action) {
      state.theme = action.payload;
      saveTheme(action.payload);
    },

    showResultModal(state) {
      state.showResultModal = true;
    },

    hideResultModal(state) {
      state.showResultModal = false;
    },

    showHowToPlay(state) {
      state.showHowToPlay = true;
    },

    hideHowToPlay(state) {
      state.showHowToPlay = false;
    },
  },
});

export const {
  toggleDarkMode,
  setDarkMode,
  setTheme,
  showResultModal,
  hideResultModal,
  showHowToPlay,
  hideHowToPlay,
} = appSlice.actions;

export default appSlice.reducer;
